import React, { CSSProperties, FunctionComponent } from 'react'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css"
import {StylePrev, StyleNext, BannerContainer, ShadowRight, ShadowLeft}  from './style'
import {isValidUrl} from '../../utils/isValidUrl'
import "./style.css"

type TypesProps ={
    arrBanner: string[],
    color: string
}


export const Banner : FunctionComponent<TypesProps> = ({arrBanner,color}) => {

    const colorIndicator = color 

    const indicatorStyles: CSSProperties = {
        background: "#fff",
        width: 8,
        height: 8,
        display: 'inline-block',
        margin: '0 8px',
        borderRadius: "50%",
    };

  const arrImg = arrBanner.filter(url => isValidUrl(url))

    return (
        <BannerContainer>
            <Carousel
                autoPlay={true}
                transitionTime={1500}
                interval={6000}
                infiniteLoop={true}
                statusFormatter={(current, total) => ""}
                showArrows={true} showThumbs={false} renderArrowPrev={(onClickHandler, hasPrev, label) =>
                    hasPrev && (
                        <><StylePrev onClick={onClickHandler}/>
                        <ShadowLeft></ShadowLeft></>
                    )
                }
            
                renderArrowNext={(onClickHandler, hasNext, label) =>
                    hasNext && (<>
                    <StyleNext onClick={onClickHandler} />
                    <ShadowRight></ShadowRight></>
                    )
                } 
            
                renderIndicator={(onClickHandler, isSelected, index, label) => {
                    if (isSelected) {
                        return (
                            <li
                                style={{ ...indicatorStyles, background: colorIndicator }}
                                aria-label={`Selected: ${label} ${index + 1}`}
                                title={`Selected: ${label} ${index + 1}`}
                            />
                        );
                    }
                    return (
                        <li
                            style={indicatorStyles}
                            onClick={onClickHandler}
                            onKeyDown={onClickHandler}
                            value={index}
                            key={index}
                            role="button"
                            tabIndex={0}
                            title={`${label} ${index + 1}`}
                            aria-label={`${label} ${index + 1}`}
                        />
                    );
                }}
            >        
                {

                arrImg.map((img,index)=>(
                    <div key={index} style={{maxHeight:500}}>
                        <img src={img} alt="image" />
                    </div>
                ))
                }
               
            </Carousel>
        </BannerContainer>
    )
}
